export default __webpack_public_path__ + "static/media/desktop_deivce.86bd5bbd.svg";